<template>
  <div>
    <label for="brandSelected"
      >Brand<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="brandSelected"
      v-model="brand"
      :options="brands"
      label="text"
      track-by="id"
      :disabled="setDisable"
      :loading="isLoading"
      placeholder="Select option"
      :style="styleObject"
    >
    </multiselect>
  </div>
</template>

<script>
import BrandService from "services/api/brand.service";

export default {
  name: "BrandDropdown",
  props: ["value", "setDisable", "required", "styleObject"],
  data() {
    return {
      brand: this.normalizeValue(this.value),
      brands: [],
      isLoading: false,
    };
  },
  async created() {
    await this.getBrands();
  },
  watch: {
    brand(newValue) {
      this.$emit("setBrand", newValue);
    },
    value(newValue) {
      this.brand = this.normalizeValue(newValue);
    },
    brands(newValue) {
      this.$emit("setBrands", newValue);
    },
  },
  methods: {
    normalizeValue(val) {
      if (val && typeof val === "object" && Object.keys(val).length === 0) {
        return null;
      }
      return val;
    },
    async getBrands() {
      this.isLoading = true;
      try {
        await BrandService.getListBrands()
          .then(async (res) => {
            const data = await res.data;
            this.brands = data.brand.map((s) => {
              return {
                id: s.code,
                text: s.name,
              };
            });
            this.brands.sort(function (a, b) {
              return -(b.code - a.code);
            });
          })
          .catch((err) => {
            console.log("Error: ", err);
          });
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
